import * as React from "react";
import styled, { css } from "styled-components";
import { Badge } from "components/bootstrap";
import useHeaderBadge from "customization/header-badge/useHeaderBadge";
const StyledBadge = styled(Badge)(
  ({ $color, theme }) => css`
    background-color: ${$color};
    color: ${theme.utils.readableColor($color)};
  `
);
const HeaderBadge = ({ smallScreen = false }) => {
  const smallScreenClass = smallScreen ? "small-scrn-badge" : "";
  const { data: badgeConfig } = useHeaderBadge();
  if (badgeConfig == null ? void 0 : badgeConfig.badge_enable) {
    return /* @__PURE__ */ React.createElement(StyledBadge, { $color: badgeConfig.badge_color, className: `${smallScreenClass} dev-badge` }, badgeConfig.badge_text);
  }
  return null;
};
export default HeaderBadge;
